// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"2c28764d","111":"2b79f57d","445":"57568bd2","453":"83088247","819":"8991a15f","952":"392b3302"}[chunkId] + ".chunk.js";
};